import { render, staticRenderFns } from "./BreathAnim.vue?vue&type=template&id=05d817a8&"
import script from "./BreathAnim.vue?vue&type=script&lang=js&"
export * from "./BreathAnim.vue?vue&type=script&lang=js&"
import style0 from "./BreathAnim.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports